import type { SequencingPlatformKey } from '../../Generated/SequencingPlatform.ts'
import { getSequencingPlatformEarlyAccessTag } from '../../Util/sequencingPlatform.ts'

/** Sits inside a platform badge; renders nothing for a platform that is generally available. */
export const SequencingPlatformEarlyAccessTag = ({ platform }: { platform?: SequencingPlatformKey | null }) => {
  const tag = getSequencingPlatformEarlyAccessTag(platform)
  if (!tag) {
    return null
  }
  return (
    <span
      data-testid="sequencing-platform-early-access-tag"
      className="ml-1.5 rounded bg-amber-100 px-1 py-px text-[10px] font-semibold uppercase tracking-wide text-amber-800"
    >
      {tag}
    </span>
  )
}
